// import '../changePassword/changePassword.css'
// import React, { useContext, useState ,useEffect } from 'react'
// import { AppContext } from '../../App'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Side from '../side/Side';
// import './week.css'


// const Week = () => {
//     const {route,setLoader}=useContext(AppContext)
//     const [week,setWeek]=useState("")
//     const [left,setLeft]=useState([])
//     const [right,setRight]=useState([])
//     const [leftCount,setLeftCount]=useState("")
//     const [rightCount,setRightCount]=useState("")
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

//     const chooseWeek =()=>{
//         setLoader(true)
//         fetch(`${route}/market/getUsersByWeek/${week}`,{
//             headers :{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//               }
//         })
//         .then(res=>res.json())
//         .then(data=>{console.log(data)
//             setLoader(false)
//         if(data.leftUsers){
//             setLeft(data.leftUsers)
//         }
//         if(data.rightUsers){
//             setRight(data.rightUsers)
//         }
//         if(data.leftCount === 0 && data.rightCount === 0){
//             toast.error("لا يوجد تسجيلات لهذ الاسبوع")
//         }
//         setLeftCount(data.leftCount)
//         setRightCount(data.rightCount)
//         })
//     }
// useEffect(()=>{
//     fetch(`${route}/market/getUsersByWeek/${week}`,{
//         headers :{
//             "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//           }
//     })
//     .then(res=>res.json())
//     .then(data=>{console.log(data)
//         setLoader(false)
//     if(data.leftUsers){
//         setLeft(data.leftUsers)
//         setWeek(data.weekNumber)
//     }
//     if(data.rightUsers){
//         setRight(data.rightUsers)
//         setWeek(data.weekNumber)
//     }
//     if(data.leftCount === 0 && data.rightCount === 0){
//         toast.error("لا يوجد تسجيلات لهذ الاسبوع")
//     }
//     setLeftCount(data.leftCount)
//     setRightCount(data.rightCount)
//     })
// },[])
 

//   return (
//    <div className="week">
//     <div className="container">
//     <h2>التسجيلات الاسبوعية</h2>
//     <label htmlFor="">
//         <button onClick={chooseWeek}>بحث</button>
//         <input type="text" value={week} onChange={(e)=>setWeek(e.target.value)} />
//          رقم الاسبوع
//     </label>
//  <div className="week-main">
//  <div className="left">
//         <div className="title"> <div className="count">{leftCount}</div> اليسار</div>
//         <div className="left-cards">
//             {left.map((user,index)=>{
//                 return(
//                     <div className="user-card" key={index}>
//                         <div className="name"> الاسم :{user.user.name}</div>
//                         <div className="name"> المكتب الخاص : {user.user.id}</div>
//                         <div className="name">تاريخ الانشاء : {new Date(user.created_at).toLocaleDateString('en-US', options)}</div>
//                     </div>
//                 )
//             })}
//         </div>
//     </div>
//     <div className="right">
// <div className="title"> <div className="count">{rightCount}</div>  اليمين</div>
// <div className="right-cards">
//             {right.map((user,index)=>{
//                 return(
//                     <div className="user-card" key={index}>
//                         <div className="name"> الاسم :{user.user.name}</div>
//                         <div className="name"> المكتب الخاص : {user.user.id}</div>
//                         <div className="name">تاريخ الانشاء : {new Date(user.created_at).toLocaleDateString('en-US', options)}</div>
//                     </div>
//                 )
//             })}
//         </div>
//     </div>
//  </div>
//     </div>
//     <Side />
//    </div>
//   )
// }

// export default Week
import "./week.scss";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../App";
import { toast } from "react-toastify";
import Side from "../side/Side";

const SkeletonCard = () => (
  <div className="user-card skeleton-card"></div>
);

const Week = () => {
  const { route, setLoader } = useContext(AppContext);
  const [week, setWeek] = useState("");
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [leftCount, setLeftCount] = useState(0);
  const [rightCount, setRightCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  const fetchWeek = () => {
    setLoading(true);
    fetch(`${route}/market/getUsersByWeek/${week}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setLeft(data.leftUsers || []);
        setRight(data.rightUsers || []);
        setLeftCount(data.leftCount || 0);
        setRightCount(data.rightCount || 0);

        if (data.leftCount === 0 && data.rightCount === 0) {
          toast.info("لا يوجد تسجيلات لهذا الأسبوع");
        }
      });
  };

  useEffect(() => {
    fetchWeek();
  }, []);

  return (
    <div className="week-page">
      <div className="week-container">
        <h2>التسجيلات الأسبوعية</h2>

        {/* ===== Filter ===== */}
        <div className="week-filter">
          <input
            type="number"
            value={week}
            onChange={(e) => setWeek(e.target.value)}
            placeholder="رقم الأسبوع"
          />
          <button onClick={fetchWeek}>بحث</button>
        </div>

        {/* ===== Content ===== */}
        <div className="week-grid">
          {/* Left */}
          <div className="week-column">
            <div className="column-title">
              اليسار <span>{leftCount}</span>
            </div>

            {loading
              ? Array.from({ length: 3 }).map((_, i) => (
                  <SkeletonCard key={i} />
                ))
              : left.map((u, i) => (
                  <div className="user-card" key={i}>
                    <div>الاسم: {u.user.name}</div>
                    <div>الكود: {u.user.id}</div>
                    <div>
                      التاريخ:{" "}
                      {new Date(u.created_at).toLocaleDateString(
                        "ar-EG",
                        options
                      )}
                    </div>
                  </div>
                ))}
          </div>

          {/* Right */}
          <div className="week-column">
            <div className="column-title">
              اليمين <span>{rightCount}</span>
            </div>

            {loading
              ? Array.from({ length: 3 }).map((_, i) => (
                  <SkeletonCard key={i} />
                ))
              : right.map((u, i) => (
                  <div className="user-card" key={i}>
                    <div>الاسم: {u.user.name}</div>
                    <div>الكود: {u.user.id}</div>
                    <div>
                      التاريخ:{" "}
                      {new Date(u.created_at).toLocaleDateString(
                        "ar-EG",
                        options
                      )}
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </div>

      <Side />
    </div>
  );
};

export default Week;
